document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const formId = urlParams.get("form_id");
  const promoId = urlParams.get("promo_id");

  if (!formId || !promoId) return;

  const FORM_ID_CLASS = "gpeb-table-column-field-41";
  const PROMO_ID_CLASS = "gpeb-table-column-field-40";
  const entriesBlocks = document.querySelectorAll(
    ".wp-block-gp-entry-blocks-entries"
  );

  let foundMatch = false;
  let fallbackBlock = null;

  entriesBlocks.forEach((block) => {
    const table = block.querySelector("table");
    const rows = table?.querySelectorAll("tbody tr") || [];
    const message = block.querySelector(
      ".wp-block-gp-entry-blocks-entries-index > p"
    );

    let hasVisibleRows = false;

    rows.forEach((row) => {
      const formCell = row.querySelector(`td.${FORM_ID_CLASS}`);
      const promoCell = row.querySelector(`td.${PROMO_ID_CLASS}`);
      const matchesForm = formCell?.textContent.trim() === formId;
      const matchesPromo = promoCell?.textContent.trim() === promoId;

      if (matchesForm && matchesPromo) {
        row.style.display = "";
        hasVisibleRows = true;
      } else {
        row.style.display = "none";
      }
    });

    if (hasVisibleRows) {
      // ✅ Show block with matching entries
      block.style.display = "";
      if (message) message.style.display = "none";
      foundMatch = true;
    } else if (
      message?.textContent.includes("No entries found") &&
      !fallbackBlock
    ) {
      // ⏳ Save fallback "no entries" block for correct form
      fallbackBlock = block;
      block.style.display = "none";
    } else {
      // ❌ Not a match, hide entire block
      block.style.display = "none";
    }
  });

  // ✅ If no matches, show fallback block
  if (!foundMatch && fallbackBlock) {
    fallbackBlock.style.display = "";
  }
});
